import styled from "styled-components";
import { Flex } from "discover.medical.react-component-library";
import {
  NAV_BREAKPOINT,
  CONTENT_OFFSET_DESKTOP,
  CONTENT_OFFSET_MOBILE,
  CONTENT_OFFSET_TABLET
} from "./utils/constants";

export const StyledApp = styled(Flex)`
  height: 100vh;

  background: linear-gradient(
    to bottom,
    ${({ theme }) => theme.colors.secondary.base} ${CONTENT_OFFSET_MOBILE}rem,
    ${({ theme }) => theme.colors.white} 0
  );

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    background: linear-gradient(
      to bottom,
      ${({ theme }) => theme.colors.secondary.base} ${CONTENT_OFFSET_TABLET}rem,
      ${({ theme }) => theme.colors.white} 0
    );
  }

  @media screen and (min-width: ${NAV_BREAKPOINT}) {
    background: linear-gradient(
      to bottom,
      ${({ theme }) => theme.colors.secondary.base} ${CONTENT_OFFSET_DESKTOP}rem,
      ${({ theme }) => theme.colors.white} 0
    );
  }
`;
